module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/a-function.js
// module id = 30
// module chunks = 1